define(["require", "exports", "jquery", "knockout", "log", "../../utils/urls", "../../utils/tools", "../../utils/kendoUtils", "../../shared/dataLogs", "../../models/CloudFileModel", "../../models/UserContext"], function (require, exports, $, ko, log, urls_1, tools, KendoUtils, DataLogs, CloudFileModel, UserContext) {
    "use strict";
    var CloudFiles = /** @class */ (function () {
        function CloudFiles() {
            this.userCanEdit = ko.observable(UserContext.hasAccess("Admin,CloudFiles.Edit,CloudFiles.Delete"));
            this.userCanDelete = ko.observable(UserContext.hasAccess("Admin,CloudFiles.Delete"));
            this.editModel = ko.observable(new CloudFileModel());
            this.clearFilterInProgress = false;
            this.filterByAny = ko.observable("");
        }
        CloudFiles.prototype.init = function () {
            var self = this;
            $("#page-title").text("Shared Assets");
            tools.ajaxGet({
                url: "/CloudFiles/GetCloudFilesLookupData",
                success: function (data) {
                    if (data.Success) {
                        self.lookupLists = data.Data.lookupLists;
                    }
                    else {
                        log.error(data.Error);
                    }
                    self.initCloudFiles(self.lookupLists.GridStructures.CloudFilesStructure);
                    ko.applyBindings(self, document.getElementById("main-container"));
                    //self.initMenu();
                    //self.initLogs();
                    $("#contextLoader").hide();
                    $("#mainContext").show();
                }
            });
        };
        CloudFiles.prototype.initCloudFiles = function (gridStructure) {
            var self = this;
            var columns = gridStructure.columns;
            columns.push({
                field: "",
                title: "",
                width: "100px",
                sortable: false,
                template: function (dataItem) {
                    var html = "";
                    if (self.userCanEdit()) {
                        html += '<a class="btn btn-sm btn-info btn-edit" href="#"><i class="fa fa-edit "></i></a>';
                    }
                    if (self.userCanDelete()) {
                        html += '&nbsp;<button class="btn btn-sm btn-danger btn-remove" href="#"><i class="fa fa-trash-o "></i></button>';
                    }
                    return html;
                }
            });
            var gridId = "cloudFilesTable";
            self.cloudFilesTable = new KendoUtils.KendoUtils();
            var gridOptions = {
                gridOptions: {
                    columns: columns,
                    autoBind: true,
                    resizable: true,
                    //reorderable: true,
                    //mobile: true,
                    scrollable: true,
                    columnMenu: true,
                    filterable: {
                        mode: "row menu",
                        extra: false
                    }
                    //toolbar: kendo.template($("#product-type-toolbar-template").html())
                },
                dataSourceOptions: {
                    transport: {
                        read: {
                            url: "/CloudFiles/GetCloudFiles",
                            type: "POST",
                            dataType: "json"
                        }
                    },
                    schema: {
                        model: gridStructure.model,
                        data: function (response) { return response.Data; },
                        total: "Total"
                    }
                },
                gridId: gridId,
                showPagerOnTop: false,
                enableExport: {
                    entityName: "CloudFile",
                    title: "Cloud Files",
                    enablePdf: false
                },
                autoHeight: {
                    totalOffset: 46 + 41 + 3
                },
                controller: self
            };
            self.cloudFilesTable.initGrid(gridOptions);
            self.filterByAny.extend({ rateLimit: 200 }).subscribe(function () {
                self.cloudFilesTable.refresh();
            });
            $("#" + gridId + " tbody").on("click", ".btn-edit", function (event) {
                var data = KendoUtils.KendoUtils.getGridRowDataItem(this);
                self.editCloudFile(data.Id);
                event.preventDefault();
            }).on("click", ".btn-remove", function (event) {
                var data = KendoUtils.KendoUtils.getGridRowDataItem(this);
                self.deleteCloudFileConfirm(data.Id, data.Name);
                event.preventDefault();
            });
        };
        CloudFiles.prototype.editCloudFile = function (id) {
            var self = this;
            var title = id > 0 ? "Edit Cloud File" : "Add Cloud File";
            tools.editModal({
                title: title,
                buttonTitle: "Save",
                type: "info",
                modalOptions: {},
                save: function (event, modal) {
                    //validate form
                    if (!self.editModel().Name()) {
                        tools.error("Name is required");
                        return;
                    }
                    if (!self.editModel().Category()) {
                        tools.error("Type is required");
                        return;
                    }
                    if (!self.editModel().FileGroup()) {
                        tools.error("Category is required");
                        return;
                    }
                    var vis = $(".k-upload .k-file", modal).is(":visible");
                    if (!self.editModel().FileName() && !vis) {
                        tools.error("File is required field");
                        return;
                    }
                    $(event.currentTarget).button("loading");
                    if (vis === false) {
                        self.saveCloudFile(event.currentTarget, modal);
                    }
                    else {
                        $(".k-upload-selected", modal).click();
                    }
                },
                opened: function (modal) {
                    var getModelCall = null;
                    if (!isNaN(id)) {
                        getModelCall = tools.ajaxGet({
                            url: "/CloudFiles/GetCloudFileById",
                            data: { id: id },
                            success: function (result) {
                                if (result.Success) {
                                    self.editModel(new CloudFileModel(result.Data));
                                }
                                else {
                                    log.error(result.Error);
                                }
                            }
                        });
                    }
                    else {
                        self.editModel(new CloudFileModel());
                    }
                    $.when(getModelCall).done(function () {
                        $(modal).find(".modal-body").html("<div data-bind=\"template: { name: 'edit-cloudfile-template', data: editModel }\"></div>");
                        ko.applyBindings(self, modal);
                        $("#cloudFile", modal).kendoUpload({
                            async: {
                                saveUrl: "/CloudFiles/SaveCloudFile",
                                autoUpload: false
                            },
                            multiple: false,
                            select: function (e) {
                                var files = e.files;
                                var error = false;
                                ko.utils.arrayForEach(files, function (file) {
                                    if (!(/\.(wav|exe)$/i).test(file.extension.toLowerCase())) {
                                        tools.error("Only wav and exe files can be uploaded!");
                                        error = true;
                                        e.preventDefault();
                                    }
                                });
                                if (error) {
                                    return;
                                }
                                setTimeout(function () {
                                    $(".k-upload-selected", modal).hide();
                                }, 10);
                                // self.uploadComplete(true);
                            },
                            upload: function (e) {
                                e.data = {
                                    id: self.editModel().Id(),
                                    name: self.editModel().Name(),
                                    category: self.editModel().Category(),
                                    fileGroup: self.editModel().FileGroup()
                                };
                            },
                            localization: {
                                select: "Drag or Select a file"
                            },
                            success: function (e) {
                                if (e.response && !e.response.Success) {
                                    tools.error(e.response.Error);
                                }
                                $(modal).modal("hide");
                                tools.success("Changes updated successfully");
                                self.cloudFilesTable.refresh();
                            }
                        });
                    });
                }
            });
        };
        CloudFiles.prototype.saveCloudFile = function (btn, modal) {
            var _this = this;
            var self = this;
            var obj = ko.mapping.toJS(self.editModel);
            obj["__RequestVerificationToken"] = $('#mainAntiForgeryTokenForm input[name="__RequestVerificationToken"]').val();
            tools.ajaxPost({
                url: "/CloudFiles/SaveCloudFile",
                data: obj
            }).done(function (result) {
                if (result.Success) {
                    tools.success("Changes updated successfully");
                    _this.cloudFilesTable.refresh();
                    $(modal).modal("hide");
                    return;
                }
                else {
                    tools.error(result.Error);
                }
            }).always(function () {
                $(btn).button("reset");
            });
        };
        CloudFiles.prototype.deleteCloudFileConfirm = function (id, name) {
            var self = this;
            tools.confirmModal({
                title: "Delete File",
                text: 'Are you sure you want to delete file "' + name + '"?',
                buttonTitle: "Delete",
                type: "danger",
                modalOptions: {}
            }, function (modal) {
                $(modal).modal("hide");
                self.deleteCloudFile(id);
            });
        };
        CloudFiles.prototype.deleteCloudFile = function (id) {
            var self = this;
            var data = {
                id: id
            };
            data["__RequestVerificationToken"] = $('#mainAntiForgeryTokenForm input[name="__RequestVerificationToken"]').val();
            tools.ajaxPost({
                url: "/CloudFiles/DeleteCloudFileConfirmed",
                data: data
            }).done(function (result) {
                if (result.Success) {
                    tools.success("File deleted successfully");
                    self.cloudFilesTable.refresh();
                }
                else {
                    tools.error(result.Error);
                }
            }).always(function () {
                //btn.button("reset");
            });
        };
        CloudFiles.prototype.clearFilter = function () {
            var self = this;
            self.filterByAny("");
        };
        CloudFiles.prototype.exportTo = function () {
            var self = this;
            self.cloudFilesTable.exportTo();
        };
        CloudFiles.prototype.initLogs = function () {
            if (UserContext.hasAccess("Admin")) {
                var dataLogs = new DataLogs("CloudFile");
                dataLogs.initKendoLogs("divLogsTable");
            }
        };
        return CloudFiles;
    }());
    setTimeout(function () {
        if (urls_1.urls.startsWith("/CloudFiles/Index")) {
            log.log("Initialize Cloud Files");
            $(function () {
                (new CloudFiles()).init();
            });
        }
    }, 0);
    return CloudFiles;
});
//# sourceMappingURL=cloudFiles.js.map


//////////////////
// WEBPACK FOOTER
// ./build/areas/cloudFiles/cloudFiles.js
// module id = 315
// module chunks = 2